import ISvgProps from '../SvgLoader/ISvgProps';
import { FC } from 'react';

export const ThisAccountIsNotMine: FC<ISvgProps> = ({ primaryColor = '#535763' }) => {
	return (
		<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="3.83077"
				y="15.7538"
				width="46.8"
				height="27.4154"
				rx="1.93846"
				stroke="#5977EB"
				strokeWidth="1.66154"
			/>
			<mask id="path-2-inside-1_1266_545" fill="white">
				<rect x="23.7695" y="8" width="6.92308" height="11.0769" rx="1.38462" />
			</mask>
			<rect
				x="23.7695"
				y="8"
				width="6.92308"
				height="11.0769"
				rx="1.38462"
				fill="#F5F5F5"
				stroke="#5977EB"
				strokeWidth="3.32308"
				mask="url(#path-2-inside-1_1266_545)"
			/>
			<circle cx="15.0655" cy="26.1978" r="3.51396" stroke="#5977EB" strokeWidth="1.67538" />
			<path
				d="M20.7556 35.989V36.2392H9.37602V35.989C9.37602 32.8466 11.9234 30.2992 15.0658 30.2992C18.2082 30.2992 20.7556 32.8466 20.7556 35.989Z"
				stroke="#5977EB"
				strokeWidth="1.67538"
			/>
			<path
				d="M45.4974 25.8616H28.3493C28.1721 25.8616 28.0254 25.9755 27.9302 26.1302C27.8344 26.286 27.7849 26.4884 27.7849 26.6923C27.7849 26.8963 27.8344 27.0987 27.9302 27.2544C28.0254 27.4092 28.1721 27.5231 28.3493 27.5231H45.4974C45.6746 27.5231 45.8213 27.4092 45.9165 27.2544C46.0123 27.0987 46.0618 26.8963 46.0618 26.6923C46.0618 26.4884 46.0123 26.286 45.9165 26.1302C45.8213 25.9755 45.6746 25.8616 45.4974 25.8616Z"
				fill="#5977EB"
				stroke="#5977EB"
				strokeWidth="0.276923"
			/>
			<path
				d="M36.0344 31.4H28.1199C28.0248 31.4 27.963 31.4655 27.9305 31.5129C27.895 31.5647 27.8682 31.6313 27.8477 31.7034C27.8064 31.8491 27.7849 32.0386 27.7849 32.2308C27.7849 32.4229 27.8064 32.6125 27.8477 32.7581C27.8682 32.8302 27.895 32.8969 27.9305 32.9487C27.963 32.9961 28.0248 33.0615 28.1199 33.0615H36.0344C36.1296 33.0615 36.1914 32.9961 36.2239 32.9487C36.2594 32.8969 36.2862 32.8302 36.3066 32.7581C36.348 32.6125 36.3695 32.4229 36.3695 32.2308C36.3695 32.0386 36.348 31.8491 36.3066 31.7034C36.2862 31.6313 36.2594 31.5647 36.2239 31.5129C36.1914 31.4655 36.1296 31.4 36.0344 31.4Z"
				fill="#5977EB"
				stroke="#5977EB"
				strokeWidth="0.276923"
			/>
			<circle cx="49.2494" cy="40.9432" r="8.37003" fill="#F5F5F5" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M49.0773 50.2575C54.3163 50.2575 58.5634 46.0105 58.5634 40.7715C58.5634 35.5325 54.3163 31.2854 49.0773 31.2854C43.8384 31.2854 39.5913 35.5325 39.5913 40.7715C39.5913 46.0105 43.8384 50.2575 49.0773 50.2575ZM48.4862 43.3715V43.5041H50.1839V43.3715C50.1873 43.0112 50.2297 42.7087 50.3113 42.464C50.3963 42.2159 50.5254 42.0001 50.6988 41.8166C50.8755 41.633 51.1015 41.4563 51.3768 41.2864C51.6895 41.0994 51.9597 40.887 52.1874 40.6491C52.4151 40.4112 52.5902 40.1393 52.7125 39.8334C52.8383 39.5275 52.9012 39.1808 52.9012 38.7934C52.9012 38.219 52.7618 37.7228 52.4831 37.3047C52.2078 36.8833 51.8221 36.5587 51.3258 36.331C50.833 36.1033 50.262 35.9894 49.6129 35.9894C49.0181 35.9894 48.4743 36.0982 47.9815 36.3157C47.492 36.5332 47.0978 36.8595 46.7987 37.2945C46.503 37.7296 46.3467 38.27 46.3297 38.9157H48.1446C48.1616 38.5963 48.2398 38.3328 48.3791 38.1255C48.5219 37.9148 48.7003 37.7585 48.9144 37.6565C49.1319 37.5511 49.3614 37.4985 49.6027 37.4985C49.8644 37.4985 50.1006 37.5528 50.3113 37.6616C50.5254 37.7704 50.6954 37.9233 50.8211 38.1204C50.9469 38.3176 51.0097 38.5504 51.0097 38.8189C51.0097 39.0568 50.9622 39.2726 50.867 39.4663C50.7718 39.6567 50.641 39.83 50.4744 39.9863C50.3113 40.1393 50.1261 40.2803 49.9187 40.4095C49.6163 40.5964 49.3597 40.802 49.1489 41.0264C48.9382 41.2473 48.7751 41.5396 48.6595 41.9032C48.5474 42.2669 48.4896 42.7563 48.4862 43.3715ZM48.583 46.359C48.804 46.5765 49.0674 46.6853 49.3732 46.6853C49.5772 46.6853 49.7624 46.636 49.9289 46.5374C50.0989 46.4355 50.2348 46.2995 50.3368 46.1296C50.4422 45.9597 50.4948 45.771 50.4948 45.5637C50.4948 45.2578 50.3827 44.9961 50.1584 44.7786C49.9374 44.5611 49.6757 44.4523 49.3732 44.4523C49.0674 44.4523 48.804 44.5611 48.583 44.7786C48.3621 44.9961 48.2517 45.2578 48.2517 45.5637C48.2517 45.8764 48.3621 46.1415 48.583 46.359Z"
				fill="#F77430"
			/>
		</svg>
	);
};
